// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.18.4-rewrite/static/js/" + chunkId + "." + {"275":"c899ee34","450":"79bdb771"}[chunkId] + ".chunk.js";
};